/**
 * Shared constants for compliance-related components
 */

// Sheriff Types — single source of truth lives in sheriffOptions.ts.
// Re-exported here (preserving the SHERIFF_TYPES name) so existing consumers
// keep working without duplicating the list.
export { ALL_SHERIFF_TYPES as SHERIFF_TYPES } from "./sheriffOptions"

// Eligibility Options
export type EligibilityOption = "Eligible" | "Ineligible" | "Failed" | "Pending"

export const ELIGIBILITY_OPTIONS: readonly EligibilityOption[] = [
  "Eligible",
  "Ineligible",
  "Failed",
  "Pending",
]
